///? Default IMPORTS

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS
///? Component & Styling IMPORTS

import { message } from "antd";
import BoxImg from "../../../assets/icons/MissingPackage.svg";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { MissingZoneWrapper } from "./MissingZone.styled";

///? Constants

export class MissingZone extends Component {
  state = {
    currentBoxId: null,
    currentOrderId: null,
    currentRackId: null,
    pickerFlow: null,
  };

  componentDidMount = () => {
    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");

    let orderValue = "";
    // let boxValue = "";
    let rackValue = "";

    //? BoxID & RackID we well get from service orderID level

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );

    // currPathArr.map((item) =>
    //   item.includes("boxId") ? (boxValue = item.split("=")[1]) : ""
    // );

    currPathArr.map((item) =>
      item.includes("rackNumber") ? (rackValue = item.split("=")[1]) : ""
    );

    const storedSelectedOption =
      JSON.parse(localStorage.getItem("pickerFlow")) || false;

    this.setState({
      currentOrderId: Base64func(orderValue, "decode"),
      // currentBoxId: Base64func(boxValue, "decode"),
      currentRackId: Base64func(rackValue, "decode"),
      pickerFlow: storedSelectedOption,
    });
  };

  redirectHome = () => {
    localStorage.setItem("pickerFlow", JSON.stringify(!this.state.pickerFlow));
    this.props.history.push("/picker");
  };

  render() {
    return (
      <div className="centerScreen">
        <MissingZoneWrapper>
          <img src={BoxImg} alt="missingZoneImg" />

          <h2>
            Box placed in <span>Missing Zone</span>
          </h2>

          <p>
            Order ID <span>{this.state.currentOrderId}</span> is placed on Rack{" "}
            <span>{this.state.currentRackId}</span>
          </p>

          <button className="bbtn" onClick={() => this.redirectHome()}>
            Go to home
          </button>
        </MissingZoneWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
});

export default withRouter(connect(mapStateToProps, {})(MissingZone));
